(function () {

    'use strict';

    angular
        .module('ib-others-fees-module')
        .controller('OthersFeesController', OthersFeesController);

    OthersFeesController.$inject = ['$scope', 'OthersFeesViewModel'];
    function OthersFeesController ($scope, OthersFeesViewModel) {

        const vm = this;
        activate();

        $scope.$watch('model', () => {
            if (vm.model.hasElements && vm.model.others.length === 0)
                activate();
        }, true);


        function activate () {
            vm.model = OthersFeesViewModel.getOthersViewModel();
        }

    }

})();
